// © Microsoft Corporation. All rights reserved.
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { Provider } from '@fluentui/react-northstar';
import { svgIconStyles } from '@fluentui/react-northstar/dist/es/themes/teams/components/SvgIcon/svgIconStyles';
import { svgIconVariables } from '@fluentui/react-northstar/dist/es/themes/teams/components/SvgIcon/svgIconVariables';
import * as siteVariables from '@fluentui/react-northstar/dist/es/themes/teams/siteVariables';
import {Route , BrowserRouter as Router  ,Routes} from 'react-router-dom'
import WaitingScreen  from 'components/WaitingScreen';
import WelcomeScreen  from 'components/WelcomeScreen';
//import Rating from 'components/Rating';
//import AbnormalRating from 'components/AbnormalRating';
import Chat from 'components/Chat';
import AfterWorkingHours from 'components/AfterWorkingHours';
import AfterRating from 'components/AfterRating';
import WaitinfSessionExpired from 'components/WaitingSessionExpired';
import OTPWrapper from 'components/OTPInput';
import OTPWrapperTesting from 'components/OTPInputTesting';
import RatingWrapper from 'components/Rating';
import AbnormalRatingWrapper from 'components/AbnormalRating';
import setLanguage from 'translation'; 

const iconTheme = {
  componentStyles: {
    SvgIcon: svgIconStyles
  },
  componentVariables: {
    SvgIcon: svgIconVariables
  },
  siteVariables
};


  

  const openUrl = (url:string) =>{
    window.location.href = url;
  }
  const handleLanguageChange = (lang:string)=>{
    setLanguage(lang);
    localStorage.setItem("lang", lang);
    let serviceMeassageAR = document.getElementById("serviceMeassageAR");
    let serviceMeassageEN = document.getElementById("serviceMeassageEN");
    if (serviceMeassageAR !== null && serviceMeassageEN !== null) {
      if(lang == "ar"){
        serviceMeassageAR.classList.add("d-block");
        serviceMeassageEN.classList.add("d-none");
        serviceMeassageAR.classList.remove("d-none");
        serviceMeassageEN.classList.remove("d-block");
      }else{
        serviceMeassageAR.classList.remove("d-block");
        serviceMeassageEN.classList.remove("d-none");
        serviceMeassageEN.classList.add("d-block");
        serviceMeassageAR.classList.add("d-none");
    }
  }
  }
  
  ReactDOM.render(
    <div className="full-h">
      <div className="headerline"></div>
    <div id="headerx">
              <div id="logoBox" onClick={() => openUrl('https://www.masdr.sa/home')}></div>
       <div id="internalLogo" onClick={() => openUrl('https://endak.masdr.sa/?isPublic=true')}></div>
    </div>
     <div className="main-container">
      <div className='content-container mt-0 mb-0'>
        <div id="languageBar" className='row'>
          <select onChange={(e) => handleLanguageChange(e.target.value)} id="languageSelector">
            <option value="ar">عربى</option>
            <option value="en">English</option>
          </select>
        </div>   
      </div>    
         <div className='row' id="content">
         <div className='col-md-12'>
           <Router>
           <Routes>          
                <Route  path='/' element={<Provider theme={iconTheme} className=""><App /> </Provider>} />
                <Route  path='/waitingScreen' element={<WaitingScreen/>}/>   {/*   done   */}
                <Route  path='/welcomeScreen' element={<WelcomeScreen/>}/> {/*   no transalation on sbc  */}
                <Route  path='/rating' element={<RatingWrapper/>}/> {/*   done   */}
                <Route  path='/abnormalRating' element={<AbnormalRatingWrapper/>}/>
                <Route  path='/chat' element={<Chat/>}/>  {/*   no transalation on sbc */}
                <Route  path='/afterWorkingHours' element={<AfterWorkingHours/>}/> {/*   no transalation on sbc  */}
                <Route  path='/afterRating' element={<AfterRating/>}/>
                <Route  path='/waitingTimeExpired' element={<WaitinfSessionExpired/>}/> {/*   no transalation on sbc */}
                <Route  path='/otp' element={<OTPWrapper/>}/> {/*   done   */}
                <Route  path='/otpTesting' element={<OTPWrapperTesting/>}/>
                
 
           </Routes>
         </Router>
         </div>
         </div>
     </div>

          <div className="footer"><span>جميع الحقوق محفوظة © ٢٠٢٤</span><span className="source">Powered by </span><span className="sourceimg"></span></div>
 
  </div>,
  document.getElementById('root'),() =>{
    var logoBox = document.getElementById("logoBox") as HTMLDivElement;
    //var internalLogo = document.getElementById("internalLogo") as HTMLDivElement;
    logoBox.className = "logoBox";
   // internalLogo.className = "internalLogo";
  }
);
 